<form>
  <div class="modal-header" ngxModalDraggable>
    <h3 class="me-4">
      {{ title }}
    </h3>
    <button type="button" class="btn-close ms-auto" aria-label="Close" (click)="close(htmlContent)">
    </button>
  </div>
  <div class="modal-body">
    <ace class="ace-transparent-background" [config]="config" [(value)]="htmlContent">
    </ace>
  </div>
</form>
